import React from "react";

export const MetricCard = ({
  title,
  value,
  Icon,
  iconColor = "text-gray-600",
  iconBg = "bg-gray-200",
  trend,
  trendValue,
}) => {
  return (
    <div
      className="group relative flex flex-col justify-between w-full h-full p-4 bg-white rounded-xl shadow-sm hover:shadow-lg border border-gray-100 hover:border-yellow-300 hover:-translate-y-0.5 active:scale-95 transition-all duration-300 overflow-hidden"
      tabIndex={0}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-2">
          {Icon && (
            <div
              className={`rounded-lg p-2 transition-all duration-300 ${iconBg} group-hover:scale-105`}
            >
              <Icon className={`text-lg ${iconColor}`} />
            </div>
          )}
          {trend && (
            <span
              className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${
                trend === "up"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
              }`}
            >
              {trend === "up" ? "↑" : "↓"} {trendValue}
            </span>
          )}
        </div>
        <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wide">
          {title}
        </h4>
        <p className="text-2xl font-bold text-gray-900 tracking-tight mt-1 group-hover:text-yellow-600 transition-colors duration-300">
          {value}
        </p>
        <div className="mt-2 h-0.5 w-0 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full transition-all duration-500 group-hover:w-full"></div>
      </div>
      <div className="absolute top-0 right-0 w-14 h-14 bg-yellow-400 opacity-5 rounded-bl-full transform translate-x-6 -translate-y-6 transition-transform duration-300 group-hover:translate-x-3 group-hover:-translate-y-3"></div>
    </div>
  );
};
